import { CancelToken } from 'axios';

const tokenMap = new Map();

export const create = id => {
  const source = CancelToken.source();

  tokenMap.set(id, source);
  return source;
};

export const has = id => tokenMap.has(id);

export const get = id => tokenMap.get(id);

export const remove = id => tokenMap.delete(id);
